// Velo API Reference: https://www.wix.com/velo/reference/api-overview/introduction

import { getCertificateById } from "backend/media.web";

$w.onReady(function () {

    const button = $w('#button5');
	const successFn = $w("#text65");
	const errorFn = $w("#text66");
	const notFoundFn = $w("#text67");
	const buttonGo = $w('#button7');

	successFn.hide();
	errorFn.hide();
	notFoundFn.hide();
	buttonGo.hide();

	buttonGo.target = "_blank";

    button.onClick((ev) => {
        button.label = "Verificando...";
        button.disable;
		successFn.hide();
		errorFn.hide();
		notFoundFn.hide();
		buttonGo.hide();

        const certificadoId = $w('#input1').value.replace(/ /g, "");

        getCertificateById(certificadoId).then((item) => {
                if (item === "notFound") {
					notFoundFn.show();
					button.label = "Verificar";
                    button.enable;
                } else {
					successFn.show();
					buttonGo.link = `https://www.fumi-integrales.com${item["link-certificados-title"]}`;
					buttonGo.show();
                    button.label = "Verificar";
                    button.enable;
                }
            })
            .catch((error) => {
				errorFn.show();
                console.log('Error getting certificate: ', error);
            })
    });
});